import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-sections">
          <div className="footer-section">
            <h3 className="footer-section-title">Company</h3>
            <div className="footer-links-column">
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <Link to="/cookies" className="footer-link">Cookie Policy</Link>
              <Link to="/termsofservice" className="footer-link">Terms of Service</Link>
            </div>
          </div>
          <div className="footer-section">
            <h3 className="footer-section-title">Platform</h3>
            <div className="footer-links-column">
              <Link to="/pricing" className="footer-link">Pricing</Link>
              <Link to="/analytics-features" className="footer-link">Analytics</Link>
              <Link to="/revenue-features" className="footer-link">Revenue</Link>
              <Link to="/content-features" className="footer-link">Content</Link>
              <Link to="/guides" className="footer-link">Guides</Link>
              <Link to="/metrics-dictionary" className="footer-link">Metrics Dictionary</Link>
            </div>
          </div>
          <div className="footer-section">
            <h3 className="footer-section-title">Guides</h3>
            <div className="footer-links-column">
              <Link to="/guides/adsense" className="footer-link">AdSense</Link>
            </div>
          </div>
          <div className="footer-section footer-section-contact">
            <Link to="/contact" className="footer-link">Contact Support</Link>
          </div>
        </div>
        <div className="footer-badge">
          <a href="https://www.foundrlist.me/product/theadshop" target="_blank" rel="noopener noreferrer">
            <img src="https://www.foundrlist.me/api/badge/theadshop?style=featured" alt="The Ad Shop" style={{width: '200px', height: '64px'}} width="200" height="64" />
          </a>
          <a href="https://www.nxgntools.com/tools/the-ad-shop" target="_blank" rel="noopener noreferrer">
            <img src="https://www.nxgntools.com/api/embed/the-ad-shop?type=FEATURED_ON" alt="NextGen Tools Badge" style={{width: '200px', height: '64px'}} width="200" height="64" />
          </a>
          <a href="https://shipyardhq.dev/products/the-ad-shop" target="_blank" rel="noopener noreferrer">
            <img src="https://shipyardhq.dev/api/embed/products/the-ad-shop?theme=light&type=featured" alt="Shipyard badge" style={{width: '200px', height: '64px'}} width="200" height="64" />
          </a>
        </div>
        <div className="footer-copyright">
          <p>
            &copy; 2025{' '}
            <a href="https://themediashop.co" target="_blank" rel="noopener noreferrer" className="copyright-link">
              The Media Shop
            </a>
            . All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

